import { Injectable } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';

const data = {
  en: {
    messages: {
      'kendo.grid.noRecords': 'No records available',
      'kendo.grid.groupPanelEmpty': 'Drag a column header and drop it here to group by that column',
      'kendo.grid.pagerFirstPage': 'Go to the first page',
      'kendo.grid.pagerPreviousPage': 'Go to the previous page',
      'kendo.grid.pagerNextPage': 'Go to the next page',
      'kendo.grid.pagerLastPage': 'Go to the last page',
      'kendo.grid.pagerPage': 'Page',
      'kendo.grid.pagerOf': 'of',
      'kendo.grid.pagerItems': 'items',
      'kendo.grid.pagerPageNumberInputTitle': 'Page Number',
      'kendo.grid.pagerItemsPerPage': 'items per page',
      'kendo.grid.filter': 'Filter',
      'kendo.grid.filterEqOperator': 'Is equal to',
      'kendo.grid.filterNotEqOperator': 'Is not equal to',
      'kendo.grid.filterIsNullOperator': 'Is null',
      'kendo.grid.filterIsNotNullOperator': 'Is not null',
      'kendo.grid.filterIsEmptyOperator': 'Is empty',
      'kendo.grid.filterIsNotEmptyOperator': 'Is not empty',
      'kendo.grid.filterStartsWithOperator': 'Starts with',
      'kendo.grid.filterContainsOperator': 'Contains',
      'kendo.grid.filterNotContainsOperator': 'Does not contain',
      'kendo.grid.filterEndsWithOperator': 'Ends with',
      'kendo.grid.filterGteOperator': 'Is greater than or equal to',
      'kendo.grid.filterGtOperator': 'Is greater than',
      'kendo.grid.filterLteOperator': 'Is less than or equal to',
      'kendo.grid.filterLtOperator': 'Is less than',
      'kendo.grid.filterIsTrue': 'Is True',
      'kendo.grid.filterIsFalse': 'Is False',
      'kendo.grid.filterBooleanAll': '(All)',
      'kendo.grid.filterAfterOrEqualOperator': 'Is after or equal to',
      'kendo.grid.filterAfterOperator': 'Is after',
      'kendo.grid.filterBeforeOperator': 'Is before',
      'kendo.grid.filterBeforeOrEqualOperator': 'Is before or equal to',
      'kendo.grid.filterFilterButton': 'Filter',
      'kendo.grid.filterClearButton': 'Clear',
      'kendo.grid.filterAndLogic': 'And',
      'kendo.grid.filterOrLogic': 'Or',
      'kendo.grid.loading': 'Loading',
      'kendo.grid.columnMenu': 'Column Menu',
      'kendo.grid.columns': 'Columns',
      'kendo.grid.lock': 'Lock',
      'kendo.grid.unlock': 'Unlock',
      'kendo.grid.sortable': 'Sortable',
      'kendo.grid.sortAscending': 'Sort Ascending',
      'kendo.grid.sortDescending': 'Sort Descending',
      'kendo.grid.sortedAscending': 'Sorted Ascending',
      'kendo.grid.sortedDescending': 'Sorted Descending',
      'kendo.grid.sortedDefault': 'Not Sorted',
      'kendo.grid.columnsApply': 'Apply',
      'kendo.grid.columnsReset': 'Reset',
      'kendo.grid.detailExpand': 'Expand Details',
      'kendo.grid.detailCollapse': 'Collapse Details',
      'kendo.grid.filterDateToday': 'TODAY',
      'kendo.grid.filterDateToggle': 'Toggle Calendar',
      'kendo.grid.filterNumericDecrement': 'Decrement',
      'kendo.grid.filterNumericIncrement': 'Increment',
      'kendo.numerictextbox.increment': 'Increase value',
      'kendo.numerictextbox.decrement': 'Decrease value',
      'kendo.dateinput.increment': 'Increase value',
      'kendo.dateinput.decrement': 'Decrease value',
      'kendo.datepicker.today': 'Today',
      'kendo.datepicker.toggle': 'Toggle calendar',
      'kendo.datetimepicker.dateTab': 'Date',
      'kendo.datetimepicker.dateTabLabel': 'Date tab',
      'kendo.datetimepicker.timeTab': 'Time',
      'kendo.datetimepicker.timeTabLabel': 'Time tab',
      'kendo.datetimepicker.toggle': 'Toggle popup',
      'kendo.datetimepicker.accept': 'Set',
      'kendo.datetimepicker.acceptLabel': 'Set',
      'kendo.datetimepicker.cancel': 'Cancel',
      'kendo.datetimepicker.cancelLabel': 'Cancel',
      'kendo.datetimepicker.now': 'NOW',
      'kendo.datetimepicker.nowLabel': 'Select now',
      'kendo.datetimepicker.today': 'TODAY',
      'kendo.timepicker.accept': 'Set',
      'kendo.timepicker.acceptLabel': 'Set',
      'kendo.timepicker.cancel': 'Cancel',
      'kendo.timepicker.cancelLabel': 'Cancel',
      'kendo.timepicker.now': 'Now',
      'kendo.timepicker.nowLabel': 'Now',
      'kendo.timepicker.toggle': 'Toggle time list',
      'kendo.autocomplete.noDataText': 'No data found',
      'kendo.autocomplete.clearTitle': 'clear',
      'kendo.combobox.noDataText': 'No data found',
      'kendo.combobox.clearTitle': 'clear',
      'kendo.dropdownlist.noDataText': 'No data found',
      'kendo.dropdownlist.clearTitle': 'clear',
      'kendo.multiselect.noDataText': 'No data found',
      'kendo.multiselect.clearTitle': 'clear',
      'kendo.calendar.today': 'Today',
      'kendo.editor.alignCenter': 'Center text',
      'kendo.editor.alignJustify': 'Justify',
      'kendo.editor.alignLeft': 'Align text left',
      'kendo.editor.alignRight': 'Align text right',
      'kendo.editor.backColor': 'Background color',
      'kendo.editor.bold': 'Bold',
      'kendo.editor.cleanFormatting': 'Clean formatting',
      'kendo.editor.createLink': 'Insert link',
      'kendo.editor.dialogApply': 'Apply',
      'kendo.editor.dialogCancel': 'Cancel',
      'kendo.editor.dialogInsert': 'Insert',
      'kendo.editor.dialogUpdate': 'Update',
      'kendo.editor.fileText': 'Text',
      'kendo.editor.fileTitle': 'Title',
      'kendo.editor.fileWebAddress': 'Web address',
      'kendo.editor.fontFamily': 'Select font family',
      'kendo.editor.fontSize': 'Select font size',
      'kendo.editor.foreColor': 'Color',
      'kendo.editor.format': 'Format',
      'kendo.editor.imageAltText': 'Alternate text',
      'kendo.editor.imageHeight': 'Height (px)',
      'kendo.editor.imageWebAddress': 'Web address',
      'kendo.editor.imageWidth': 'Width (px)',
      'kendo.editor.indent': 'Indent',
      'kendo.editor.insertFile': 'Insert file',
      'kendo.editor.insertImage': 'Insert image',
      'kendo.editor.insertOrderedList': 'Insert ordered list',
      'kendo.editor.insertUnorderedList': 'Insert unordered list',
      'kendo.editor.italic': 'Italic',
      'kendo.editor.linkOpenInNewWindow': 'Open link in new window',
      'kendo.editor.linkText': 'Text',
      'kendo.editor.linkTitle': 'Title',
      'kendo.editor.linkWebAddress': 'Web address',
      'kendo.editor.outdent': 'Outdent',
      'kendo.editor.redo': 'Redo',
      'kendo.editor.strikethrough': 'Strikethrough',
      'kendo.editor.subscript': 'Subscript',
      'kendo.editor.superscript': 'Superscript',
      'kendo.editor.underline': 'Underline',
      'kendo.editor.unlink': 'Remove Link',
      'kendo.editor.undo': 'Undo',
      'kendo.editor.viewSource': 'View source',
      'kendo.editor.insertTable': 'Insert Table',
      'kendo.editor.addColumnBefore': 'Add column before',
      'kendo.editor.addColumnAfter': 'Add column after',
      'kendo.editor.addRowBefore': 'Add row before',
      'kendo.editor.addRowAfter': 'Add row after',
      'kendo.editor.deleteColumn': 'Delete column',
      'kendo.editor.deleteRow': 'Delete row',
      'kendo.editor.deleteTable': 'Delete table',
      'kendo.textbox.clearTitle': 'Clear',
      'kendo.switch.on': 'On',
      'kendo.switch.off': 'Off',
    }
  },
  es: {
    messages: {
      'kendo.grid.noRecords': 'No hay registros disponibles',
      'kendo.grid.groupPanelEmpty': 'Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio',
      'kendo.grid.pagerFirstPage': 'Ir a la primera página',
      'kendo.grid.pagerPreviousPage': 'Ir a la página anterior',
      'kendo.grid.pagerNextPage': 'Ir a la página siguiente',
      'kendo.grid.pagerLastPage': 'Ir a la última página',
      'kendo.grid.pagerPage': 'Página',
      'kendo.grid.pagerOf': 'de',
      'kendo.grid.pagerItems': 'Registros',
      'kendo.grid.pagerPageNumberInputTitle': 'Número de página',
      'kendo.grid.pagerItemsPerPage': 'Registros por página',
      'kendo.grid.filter': 'Filtrar',
      'kendo.grid.filterEqOperator': 'Es igual a',
      'kendo.grid.filterNotEqOperator': 'No es igual a',
      'kendo.grid.filterIsNullOperator': 'Es nulo',
      'kendo.grid.filterIsNotNullOperator': 'No es nulo',
      'kendo.grid.filterIsEmptyOperator': 'Está vacío',
      'kendo.grid.filterIsNotEmptyOperator': 'No está vacío',
      'kendo.grid.filterStartsWithOperator': 'Comienza con',
      'kendo.grid.filterContainsOperator': 'Contiene',
      'kendo.grid.filterNotContainsOperator': 'No contiene',
      'kendo.grid.filterEndsWithOperator': 'Termina en',
      'kendo.grid.filterGteOperator': 'Es mayor o igual que',
      'kendo.grid.filterGtOperator': 'Es mayor que',
      'kendo.grid.filterLteOperator': 'Es menor o igual que',
      'kendo.grid.filterLtOperator': 'menos que',
      'kendo.grid.filterIsTrue': 'Sí',
      'kendo.grid.filterIsFalse': 'No',
      'kendo.grid.filterBooleanAll': '(Todas)',
      'kendo.grid.filterAfterOrEqualOperator': 'Es posterior o igual a',
      'kendo.grid.filterAfterOperator': 'Es posterior',
      'kendo.grid.filterBeforeOperator': 'Es anterior',
      'kendo.grid.filterBeforeOrEqualOperator': 'Es anterior o igual a',
      'kendo.grid.filterFilterButton': 'Filtrar',
      'kendo.grid.filterClearButton': 'Limpiar filtros',
      'kendo.grid.filterAndLogic': 'Y',
      'kendo.grid.filterOrLogic': 'O',
      'kendo.grid.loading': 'Cargando',
      'kendo.grid.columnMenu': 'Menú de columna',
      'kendo.grid.columns': 'Columnas',
      'kendo.grid.lock': 'Bloquear',
      'kendo.grid.unlock': 'Desbloquear',
      'kendo.grid.sortable': 'Ordenable',
      'kendo.grid.sortAscending': 'Orden ascendente',
      'kendo.grid.sortDescending': 'Orden descendente',
      'kendo.grid.sortedAscending': 'Ordenado ascendentemente',
      'kendo.grid.sortedDescending': 'Ordenada descendentemente',
      'kendo.grid.sortedDefault': 'No ordenada',
      'kendo.grid.columnsApply': 'Aplicar',
      'kendo.grid.columnsReset': 'Reiniciar',
      'kendo.grid.detailExpand': 'Expandir detalles',
      'kendo.grid.detailCollapse': 'Ocultar detalles',
      'kendo.grid.filterDateToday': 'HOY',
      'kendo.grid.filterDateToggle': 'Alternar calendario',
      'kendo.grid.filterNumericDecrement': 'Decremento',
      'kendo.grid.filterNumericIncrement': 'Incremento',
      'kendo.numerictextbox.increment': 'Incrementar valor',
      'kendo.numerictextbox.decrement': 'Disminuir valor',
      'kendo.dateinput.increment': 'Incrementar valor',
      'kendo.dateinput.decrement': 'Disminuir valor',
      'kendo.datepicker.today': 'Hoy',
      'kendo.datepicker.toggle': 'Alternar calendario',
      'kendo.datetimepicker.dateTab': 'Fecha',
      'kendo.datetimepicker.dateTabLabel': 'Mostrar fecha',
      'kendo.datetimepicker.timeTab': 'Hora',
      'kendo.datetimepicker.timeTabLabel': 'Mostrar hora',
      'kendo.datetimepicker.toggle': 'Cambiar calendario',
      'kendo.datetimepicker.accept': 'Aceptar',
      'kendo.datetimepicker.acceptLabel': 'Aceptar',
      'kendo.datetimepicker.cancel': 'Cancelar',
      'kendo.datetimepicker.cancelLabel': 'Cancelar',
      'kendo.datetimepicker.now': 'AHORA',
      'kendo.datetimepicker.nowLabel': 'Ahora',
      'kendo.datetimepicker.today': 'HOY',
      'kendo.timepicker.accept': 'Aceptar',
      'kendo.timepicker.acceptLabel': 'Aceptar',
      'kendo.timepicker.cancel': 'Cancelar',
      'kendo.timepicker.cancelLabel': 'Cancelar',
      'kendo.timepicker.now': 'Ahora',
      'kendo.timepicker.nowLabel': 'Ahora',
      'kendo.timepicker.toggle': 'Alternar lista de hora',
      'kendo.autocomplete.noDataText': 'Datos no encontrados',
      'kendo.autocomplete.clearTitle': 'Borrar',
      'kendo.combobox.noDataText': 'Datos no encontrados',
      'kendo.combobox.clearTitle': 'Borrar',
      'kendo.dropdownlist.noDataText': 'Datos no encontrados',
      'kendo.dropdownlist.clearTitle': 'Borrar',
      'kendo.multiselect.noDataText': 'Datos no encontrados',
      'kendo.multiselect.clearTitle': 'Borrar',
      'kendo.calendar.today': 'Hoy',
      'kendo.editor.alignCenter': 'Centrar texto',
      'kendo.editor.alignJustify': 'Justificar',
      'kendo.editor.alignLeft': 'Alinear texto a la izquierda',
      'kendo.editor.alignRight': 'Alinear texto a la derecha',
      'kendo.editor.backColor': 'Color de fondo',
      'kendo.editor.bold': 'Negrita',
      'kendo.editor.cleanFormatting': 'Limpiar formato',
      'kendo.editor.createLink': 'Insertar el link',
      'kendo.editor.dialogApply': 'Aplicar',
      'kendo.editor.dialogCancel': 'Cancelar',
      'kendo.editor.dialogInsert': 'Insertar',
      'kendo.editor.dialogUpdate': 'Actualizar',
      'kendo.editor.fileText': 'Texto',
      'kendo.editor.fileTitle': 'Título',
      'kendo.editor.fileWebAddress': 'Dirección web',
      'kendo.editor.fontFamily': 'Seleccionar tipo de fuente',
      'kendo.editor.fontSize': 'Seleccionar tamaño de fuente',
      'kendo.editor.foreColor': 'Color',
      'kendo.editor.format': 'Formato',
      'kendo.editor.imageAltText': 'Texto alternativo',
      'kendo.editor.imageHeight': 'Altura  (px)',
      'kendo.editor.imageWebAddress': 'Dirección web',
      'kendo.editor.imageWidth': 'Anchura (px)',
      'kendo.editor.indent': 'Sangría',
      'kendo.editor.insertFile': 'Insertar archivo',
      'kendo.editor.insertImage': 'Insertar imagen',
      'kendo.editor.insertOrderedList': 'Insertar lista ordenada',
      'kendo.editor.insertUnorderedList': 'Insertar lista desordenada',
      'kendo.editor.italic': 'Itálica',
      'kendo.editor.linkOpenInNewWindow': 'Abrir enlace en una nueva ventana',
      'kendo.editor.linkText': 'Texto',
      'kendo.editor.linkTitle': 'Título',
      'kendo.editor.linkWebAddress': 'Dirección web',
      'kendo.editor.outdent': 'Sangría',
      'kendo.editor.redo': 'Rehacer',
      'kendo.editor.strikethrough': 'Tachado',
      'kendo.editor.subscript': 'Subíndice',
      'kendo.editor.superscript': 'Superíndice',
      'kendo.editor.underline': 'Subrayar',
      'kendo.editor.unlink': 'Eliminar enlace',
      'kendo.editor.undo': 'Deshacer',
      'kendo.editor.viewSource': 'Ver fuente',
      'kendo.editor.insertTable': 'Insertar tabla',
      'kendo.editor.addColumnBefore': 'Agregar columna antes',
      'kendo.editor.addColumnAfter': 'Agregar columna después',
      'kendo.editor.addRowBefore': 'Agregar fila antes',
      'kendo.editor.addRowAfter': 'Agregar fila después',
      'kendo.editor.deleteColumn': 'Eliminar columna',
      'kendo.editor.deleteRow': 'Eliminar fila',
      'kendo.editor.deleteTable': 'Eliminar tabla',
      'kendo.textbox.clearTitle': 'Borrar',
      'kendo.switch.on': 'On',
      'kendo.switch.off': 'Off',
    }
  },
  de: {
    messages: {
      'kendo.grid.noRecords': 'Keine Aufzeichnungen verfügbar',
      'kendo.grid.groupPanelEmpty': 'Ziehen Sie eine Spaltenüberschrift hierher, um nach dieser Spalte zu gruppieren',
      'kendo.grid.pagerFirstPage': 'Zur ersten Seite',
      'kendo.grid.pagerPreviousPage': 'Zur vorherigen Seite',
      'kendo.grid.pagerNextPage': 'Zur nächsten Seite',
      'kendo.grid.pagerLastPage': 'Zur letzten Seite',
      'kendo.grid.pagerPage': 'Seite',
      'kendo.grid.pagerOf': 'von',
      'kendo.grid.pagerItems': 'Elemente',
      'kendo.grid.pagerPageNumberInputTitle': 'Seitennummer',
      'kendo.grid.pagerItemsPerPage': 'Elemente pro Seite',
      'kendo.grid.filter': 'Filter',
      'kendo.grid.filterEqOperator': 'ist gleich',
      'kendo.grid.filterNotEqOperator': 'ist nicht gleich',
      'kendo.grid.filterIsNullOperator': 'ist Null',
      'kendo.grid.filterIsNotNullOperator': 'ist nicht Null',
      'kendo.grid.filterIsEmptyOperator': 'ist leer',
      'kendo.grid.filterIsNotEmptyOperator': 'ist nicht leer',
      'kendo.grid.filterStartsWithOperator': 'beginnt mit',
      'kendo.grid.filterContainsOperator': 'beinhaltet',
      'kendo.grid.filterNotContainsOperator': 'beinhaltet nicht',
      'kendo.grid.filterEndsWithOperator': 'endet mit',
      'kendo.grid.filterGteOperator': 'ist größer als oder gleich',
      'kendo.grid.filterGtOperator': 'ist größer als',
      'kendo.grid.filterLteOperator': 'ist kleiner oder gleich als',
      'kendo.grid.filterLtOperator': 'ist kleiner als',
      'kendo.grid.filterIsTrue': 'ist richtig',
      'kendo.grid.filterIsFalse': 'ist falsch',
      'kendo.grid.filterBooleanAll': '(Alle)',
      'kendo.grid.filterAfterOrEqualOperator': 'ist gleich oder später',
      'kendo.grid.filterAfterOperator': 'ist später als',
      'kendo.grid.filterBeforeOperator': 'ist früher als',
      'kendo.grid.filterBeforeOrEqualOperator': 'ist gleich oder früher als',
      'kendo.grid.filterFilterButton': 'Filtern',
      'kendo.grid.filterClearButton': 'Löschen',
      'kendo.grid.filterAndLogic': 'und',
      'kendo.grid.filterOrLogic': 'oder',
      'kendo.grid.loading': 'Kalender umschalten',
      'kendo.grid.columnMenu': 'Spaltenmenü',
      'kendo.grid.columns': 'Spalten',
      'kendo.grid.lock': 'Sperren',
      'kendo.grid.unlock': 'Entsperren',
      'kendo.grid.sortable': 'Sortierbar',
      'kendo.grid.sortAscending': 'Aufsteigend sortieren',
      'kendo.grid.sortDescending': 'Absteigend sortieren',
      'kendo.grid.sortedAscending': 'Aufsteigend sortiert',
      'kendo.grid.sortedDescending': 'Absteigend sortiert',
      'kendo.grid.sortedDefault': 'Nicht sortiert',
      'kendo.grid.columnsApply': 'Übernehmen',
      'kendo.grid.columnsReset': 'Zurücksetzen',
      'kendo.grid.detailExpand': 'Erweitern Sie Details',
      'kendo.grid.detailCollapse': 'Details reduzieren',
      'kendo.grid.filterDateToday': 'HEUTE',
      'kendo.grid.filterDateToggle': 'Kalender umschalten',
      'kendo.grid.filterNumericDecrement': 'Wert verringern',
      'kendo.grid.filterNumericIncrement': 'Wert erhöhen',
      'kendo.numerictextbox.increment': 'Wert erhöhen',
      'kendo.numerictextbox.decrement': 'Disminuir valor',
      'kendo.dateinput.increment': 'Wert erhöhen',
      'kendo.dateinput.decrement': 'Disminuir valor',
      'kendo.datepicker.today': 'Heute',
      'kendo.datepicker.toggle': 'Kalender umschalten',
      'kendo.datetimepicker.dateTab': 'Datum',
      'kendo.datetimepicker.dateTabLabel': 'Datum',
      'kendo.datetimepicker.timeTab': 'Zeit',
      'kendo.datetimepicker.timeTabLabel': 'Zeit',
      'kendo.datetimepicker.toggle': 'Umschalten',
      'kendo.datetimepicker.accept': 'Setzen',
      'kendo.datetimepicker.acceptLabel': 'Setzen',
      'kendo.datetimepicker.cancel': 'Abbrechen',
      'kendo.datetimepicker.cancelLabel': 'Abbrechen',
      'kendo.datetimepicker.now': 'JETZT',
      'kendo.datetimepicker.nowLabel': 'Jetzt',
      'kendo.datetimepicker.today': 'HEUTE',
      'kendo.timepicker.accept': 'Setzen',
      'kendo.timepicker.acceptLabel': 'Setzen',
      'kendo.timepicker.cancel': 'Abbrechen',
      'kendo.timepicker.cancelLabel': 'Abbrechen',
      'kendo.timepicker.now': 'Jetzt',
      'kendo.timepicker.nowLabel': 'Jetzt',
      'kendo.timepicker.toggle': 'Zeitleiste umschalten',
      'kendo.autocomplete.noDataText': 'Keine Daten gefunden',
      'kendo.autocomplete.clearTitle': 'Leeren',
      'kendo.combobox.noDataText': 'Keine Daten gefunden',
      'kendo.combobox.clearTitle': 'Leeren',
      'kendo.dropdownlist.noDataText': 'Keine Daten gefunden',
      'kendo.dropdownlist.clearTitle': 'Leeren',
      'kendo.multiselect.noDataText': 'Keine Daten gefunden',
      'kendo.multiselect.clearTitle': 'Leeren',
      'kendo.calendar.today': 'Heute',
      'kendo.editor.alignCenter': 'Text zentrieren',
      'kendo.editor.alignJustify': 'Rechtfertigen',
      'kendo.editor.alignLeft': 'Text links ausrichten',
      'kendo.editor.alignRight': 'Text rechts ausrichten',
      'kendo.editor.backColor': 'Hintergrundfarbe',
      'kendo.editor.bold': 'Fett gedruckt',
      'kendo.editor.cleanFormatting': 'Saubere Formatierung',
      'kendo.editor.createLink': 'Link einfügen',
      'kendo.editor.dialogApply': 'Anwenden',
      'kendo.editor.dialogCancel': 'Stornieren',
      'kendo.editor.dialogInsert': 'Einfügen',
      'kendo.editor.dialogUpdate': 'Aktualisieren',
      'kendo.editor.fileText': 'Text',
      'kendo.editor.fileTitle': 'Titel',
      'kendo.editor.fileWebAddress': 'Webadresse',
      'kendo.editor.fontFamily': 'Schriftfamilie auswählen',
      'kendo.editor.fontSize': 'Select font size',
      'kendo.editor.foreColor': 'Farbe',
      'kendo.editor.format': 'Format',
      'kendo.editor.imageAltText': 'Alternate text',
      'kendo.editor.imageHeight': 'Höhe (px)',
      'kendo.editor.imageWebAddress': 'Webadresse',
      'kendo.editor.imageWidth': 'Breite (px)',
      'kendo.editor.indent': 'Einzug',
      'kendo.editor.insertFile': 'Datei einfügen',
      'kendo.editor.insertImage': 'Bild einfügen',
      'kendo.editor.insertOrderedList': 'Bestellte Liste einfügen',
      'kendo.editor.insertUnorderedList': 'Fügen Sie eine ungeordnete Liste ein',
      'kendo.editor.italic': 'Kursiv',
      'kendo.editor.linkOpenInNewWindow': 'Link in neuem Fenster öffnen',
      'kendo.editor.linkText': 'Text',
      'kendo.editor.linkTitle': 'Titel',
      'kendo.editor.linkWebAddress': 'Webadresse',
      'kendo.editor.outdent': 'Outdent',
      'kendo.editor.redo': 'Wiederholen',
      'kendo.editor.strikethrough': 'Durchgestrichen',
      'kendo.editor.subscript': 'Subscript',
      'kendo.editor.superscript': 'Hochgestellt',
      'kendo.editor.underline': 'Unterstreichen',
      'kendo.editor.unlink': 'Link entfernen',
      'kendo.editor.undo': 'Rückgängig machen',
      'kendo.editor.viewSource': 'Quelltext anzeigen',
      'kendo.editor.insertTable': 'Tabelle einfügen',
      'kendo.editor.addColumnBefore': 'Spalte vorher hinzufügen',
      'kendo.editor.addColumnAfter': 'Spalte nach hinzufügen',
      'kendo.editor.addRowBefore': 'Zeile vorher hinzufügen',
      'kendo.editor.addRowAfter': 'Zeile nach hinzufügen',
      'kendo.editor.deleteColumn': 'Spalte löschen',
      'kendo.editor.deleteRow': 'Zeile löschen',
      'kendo.editor.deleteTable': 'Tabelle löschen',
      'kendo.textbox.clearTitle': 'Löschen',
      'kendo.switch.on': 'Ein',
      'kendo.switch.off': 'Aus',
    }
  }
};

@Injectable({
  providedIn: 'root'
})
export class KendoMessageService extends MessageService
{
  private localeId = 'en';

  constructor(private intl: IntlService)
  {
    super();
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.localeId = this.intl['locale'];
  }

  public get messages(): any
  {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.localeId = this.intl['locale'];
    const lang = data[this.localeId.substring(0, 2)];
    if (lang)
    {
      return lang.messages;
    }
  }

  public get language(): string
  {
    return this.localeId;
  }

  public set language(value: string)
  {
    const lang = data[value];
    if (lang)
    {
      this.localeId = value;
      this.notify();
    }
  }

  public get(key: string): string
  {
    return this.messages[key];
  }
}
